import PropTypes from 'prop-types'

const Brand = PropTypes.shape({
  id: PropTypes.number,
  title: PropTypes.string,
})

const Product = PropTypes.shape({
  actualOffer: PropTypes.shape({
    id: PropTypes.number,
    inStockCount: PropTypes.number,
  }),
  biggestOldPrice: PropTypes.number,
  id: PropTypes.number,
  images: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string }))),
  smallestPrice: PropTypes.number,
  title: PropTypes.string,
  url: PropTypes.string,
})

const Options = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
}))

const AllOptions = PropTypes.shape({
  brands: Options,
  categories: Options,
})

const Values = PropTypes.shape({
  brands: PropTypes.arrayOf(PropTypes.string),
  categories: PropTypes.arrayOf(PropTypes.number),
})

const PropertyValue = PropTypes.shape({
  id: PropTypes.number,
  value: PropTypes.string,
})

const Property = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  values: PropTypes.arrayOf(PropertyValue),
})

const Color = PropTypes.shape({
  id: PropTypes.number,
  color: PropTypes.string,
})

export default {
  AllOptions,
  Brand,
  Color,
  Options,
  Product,
  Property,
  PropertyValue,
  Values,
}
